import React from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteProps, RouteComponentProps } from 'react-router';
import { getJoinRoutes, JoinRoutes } from '../../selectors/routeSelectors';
import StepNavigation, {
  StepNavigationProps,
} from '../../components/StepNavigation/StepNavigation';
import { appThunk } from '../../actions';
import { IAppState } from '../../types/state.d';

type JoinStepNavigationContainerProps = RouteComponentProps<unknown> & {
  pushToPage: typeof appThunk.pushToPage;
  joinRoutes: JoinRoutes;
  currentStep?: number;
};

export const JoinStepNavigationContainer = ({
  pushToPage,
  joinRoutes,
}: JoinStepNavigationContainerProps) => {
  const { steps, prevStep, currentIndex } = joinRoutes;
  const props: StepNavigationProps = {
    currentStep: currentIndex + 1,
    totalSteps: steps.length,
  };
  if (prevStep) {
    props.onBackButtonClick = () => pushToPage(prevStep);
  }

  if (steps.length > 1) {
    return <StepNavigation {...props} />;
  }

  return null;
};

const mapStateToProps = (state: IAppState, ownProps: RouteProps) => ({
  joinRoutes: getJoinRoutes(state, ownProps),
});
const mapDispatchToProps = {
  pushToPage: appThunk.pushToPage,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(JoinStepNavigationContainer),
);
